var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 261,
    viewBox: "0 0 260 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_5317)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36.2969,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.7969,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.744 76.1504C104.358 76.1504 105.943 87.1594 105.943 87.1594L105.971 98.565H130.197V101.989H96.3492C96.3492 101.989 80.1045 100.147 80.1045 125.761C80.1045 151.377 94.2832 150.468 94.2832 150.468H102.745V138.582C102.745 138.582 102.289 124.403 116.697 124.403H140.725C140.725 124.403 154.224 124.621 154.224 111.356V89.4238C154.224 89.4238 156.275 76.1504 129.744 76.1504ZM116.386 83.8205C116.959 83.8199 117.526 83.9323 118.055 84.1512C118.584 84.37 119.064 84.691 119.469 85.0958C119.874 85.5006 120.195 85.9812 120.414 86.5102C120.633 87.0392 120.745 87.6062 120.744 88.1786C120.745 88.7511 120.633 89.3181 120.414 89.847C120.195 90.376 119.874 90.8567 119.469 91.2615C119.064 91.6663 118.584 91.9873 118.055 92.2061C117.526 92.4249 116.959 92.5373 116.386 92.5368C115.814 92.5373 115.247 92.4249 114.718 92.2061C114.189 91.9873 113.708 91.6663 113.303 91.2615C112.899 90.8567 112.578 90.376 112.359 89.847C112.14 89.3181 112.028 88.7511 112.028 88.1786C112.028 87.6062 112.14 87.0392 112.359 86.5102C112.578 85.9812 112.899 85.5006 113.303 85.0958C113.708 84.691 114.189 84.37 114.718 84.1512C115.247 83.9323 115.814 83.8199 116.386 83.8205V83.8205Z",
    fill: "url(#paint0_linear_936_5317)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.465 175.631C155.851 175.631 154.266 164.622 154.266 164.622L154.238 153.216H130.012V149.792H163.86C163.86 149.792 180.104 151.634 180.104 126.019C180.104 100.404 165.926 101.313 165.926 101.313H157.464V113.199C157.464 113.199 157.92 127.377 143.511 127.377H119.484C119.484 127.377 105.984 127.159 105.984 140.425V162.358C105.984 162.358 103.935 175.631 130.465 175.631H130.465ZM143.823 167.961C143.251 167.962 142.684 167.85 142.155 167.631C141.626 167.412 141.145 167.091 140.74 166.686C140.335 166.281 140.014 165.801 139.796 165.272C139.577 164.743 139.464 164.176 139.465 163.603C139.464 163.031 139.577 162.464 139.795 161.935C140.014 161.406 140.335 160.925 140.74 160.52C141.145 160.115 141.626 159.794 142.155 159.575C142.684 159.357 143.251 159.244 143.823 159.245C144.396 159.244 144.962 159.357 145.491 159.575C146.02 159.794 146.501 160.115 146.906 160.52C147.311 160.925 147.632 161.405 147.851 161.934C148.069 162.463 148.182 163.03 148.181 163.603C148.182 164.175 148.069 164.742 147.851 165.271C147.632 165.8 147.311 166.281 146.906 166.686C146.501 167.09 146.02 167.411 145.491 167.63C144.962 167.849 144.396 167.962 143.823 167.961V167.961Z",
    fill: "url(#paint1_linear_936_5317)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_5317",
    x: 0,
    y: 0.296875,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_5317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_5317",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_936_5317",
    x1: 89.7145,
    y1: 85.098,
    x2: 139.271,
    y2: 134.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_936_5317",
    x1: 120.132,
    y1: 116.603,
    x2: 173.351,
    y2: 166.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.b5f9d39de49709e839f2805368cd6534.svg";
export { ForwardRef as ReactComponent };